import { Helmet } from 'react-helmet-async';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { blogPosts } from '../data/blogPosts';
import { BlogHero } from '../components/blog/BlogHero';
import { BlogPostCard } from '../components/blog/BlogPostCard';
import { BlogCTA } from '../components/blog/BlogCTA';

export default function Blog() {
    return (
        <div data-testid="blog-page">
            <Helmet>
                <title>Blog - White Glove Hiring</title>
                <meta name="description" content="Clear thinking on VA hiring, business operations, and building sustainable leverage. Articles for serious business owners." />
                <meta property="og:title" content="Blog - White Glove Hiring" />
                <meta property="og:description" content="Insights on VA hiring, operational systems, and building real business leverage. Written by operators, for operators." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/blog`} />
                <meta property="og:image" content={OG_IMAGE} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/blog`} />
            </Helmet>

            <BlogHero />

            <section className="bg-white py-24 md:py-32">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {blogPosts.map((post, i) => (
                            <BlogPostCard key={post.slug} post={post} index={i} />
                        ))}
                    </div>
                </div>
            </section>

            <BlogCTA />
        </div>
    );
}
